import { Permission, User, Territory } from 't2-graphql-types';

export const getAllPermissionsInRoles = (roles: User['roles']): (Permission & { territoryId?: Territory['id'] })[] =>
  (roles || [])
    .map((role) => (role?.permissions || []).map((p) => ({ ...p, territoryId: role?.territory?.id })))
    .flat();
